// import './../action/CourseInfo.action'
import { DETAILS, REAST_DETAIL } from '../type/CourseInfo.type';
const defaultData = {
	base: {},
	lessonsList: [],
	getbuyStatus: false
};

const CourseInfo = (state = defaultData, action) => {
	let copyState = { ...state };
	switch (action.type) {
		case DETAILS:
			copyState.base = action.res.base;
			copyState.lessonsList = action.res.lessonsList;
			return copyState;
		case 'a':
			copyState.getbuyStatus = action.res;
			return copyState;
		case REAST_DETAIL:
			copyState = action.res;
			return copyState;
		default:
			return copyState;
	}
};
export default CourseInfo;



// WEBPACK FOOTER //
// ./src/redux/reducer/CourseInfo.reducer.js